import { useHistory } from '@ztechapps/common.hook'
import type { Adjustment, RouteDef } from '@ztechapps/common.contract'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'
import type { AdjustmentAddFormValues } from './Context'
import { useMutation } from '@ztechapps/common.hook'
import { adjustmentDocumentQueries } from '@ztechapps/adjustment.common'

export const useAdjustmentAdd = () => {
  const [onAdd] = useMutation({ ...adjustmentDocumentQueries.createConfig })
  const history = useHistory()
  const adjustmentItemRoute = useInject<RouteDef>(WebuiIocKey.routes.adjustmentItem)

  const onSubmit = async ({ product, quantity }: AdjustmentAddFormValues): Promise<void> => {
    const input = {
      items: [
        {
          product: {
            _id: product?._id,
          },
          quantity,
        },
      ],
    } as Adjustment

    const { data } = await onAdd({ input })
    const adjustment = data?.createAdjustment

    // if then navigate to necessary field is no error then navigate to
    const route = adjustmentItemRoute.altPath({
      _id: adjustment?._id,
    })

    history.push(route)
  }

  return { onSubmit }
}
